/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *\

  Some basic math like rounding

  Author Alex Lowe

\* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

const _2PI = 2*Math.PI
const _2PId360 = _2PI/360
const _360d2PI = 360/_2PI

/**
 * round a number to numDec number of decimals. handy dandy.
 *
 */
export const roundTo = (input, numDec) => {
  var m = Math.pow(10,numDec);
  return Math.round(input*m)/m;
}

/**
 * returns a random float between two boundaries, inclusive
 *
 */
export const randomFloat = (floor, ceiling) => {
  return  (ceiling - floor)*(Math.random()) + floor;
}
        
/**
 * returns a random integer between two boundaries, inclusive.
 *
 */
export const randomInt = (floor, ceiling) => {
  return Math.round(randomFloat(floor,ceiling));
}

export const deg2rad = (deg) => {
  //2PI     X
  //___  = ___
  //360    deg
  return _2PId360 * deg
}

export const rad2deg = (rad) => {
  return _360d2PI * rad
}

//https://stackoverflow.com/questions/4780837/is-there-an-equivalent-to-e-pagex-position-for-touchstart-event-as-there-is-fo
export const pointerEventToXY = (e) => {
  const out = {x:0, y:0};
  if(e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel'){
    var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
    out.x = touch.pageX;
    out.y = touch.pageY;
  } else if (e.type == 'mousedown' || e.type == 'mouseup' || e.type == 'mousemove' || e.type == 'mouseover'|| e.type=='mouseout' || e.type=='mouseenter' || e.type=='mouseleave') {
    out.x = e.pageX;
    out.y = e.pageY;
  }
  return out;
};


//originally used for google maps.
//the zoom goes from 0 to 22, but practically speaking 
//we really start caring when its in the range of 8 to 15.
//We don't really care if it's over 15 and we don't really want
//to show anything if it's less than 8 because that's too far away.
//
// flr: 5 ceil: 100
// flr: 10 ceil: 1
// flr: 1  cei: 10
//
export const rescaleInteger = (z, min, max, flr, ceil) => {

  if(z < min) {
    return flr
  }
  if(z > max) {
    return ceil
  }
  //so 8 and 15 at this point and we want to rescale to 0 and 10.
  //
  // z: 
  // 8 9 10 11 12 13 14 15
  //
  // z' = z - min:
  // 0  1  2  3  4  5  6  7
  //
  // z' = (z - 8) * (10-1)/(15 - 8):
  //
  //
  // z: 8  z': 0
  // z: 9  z': 1.2857142857142858
  // z: 10 z': 2.5714285714285716
  // z: 11 z': 3.8571428571428577
  // z: 12 z': 5.142857142857143
  // z: 13 z': 6.428571428571429
  // z: 14 z': 7.714285714285715
  // z: 15 z': 9
  //
  // z' = Math.round((z - 8) * (10-1)/(15 - 8)) + 1
  // z:  8  9  10  11  12  13  14  15
  // z': 1  2  4   5   6   7   9   10
  //
  const zScaled = Math.round((z-min) * ((ceil-flr)/(max-min))) + flr
  return zScaled;
}